import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  amount: number | string
  allowance: Allowance
}

const Total = ({ amount, allowance }: Props) => {
  const title = allowance.isDays
    ? i18n.t('time_off.taken_tooltip.total_days')
    : i18n.t('time_off.taken_tooltip.total_hours')

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal color="grey000White">{title}</Text.Normal>
        <Text.Normal color="grey000White">{amount || 0}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200" color="grey000White">
          {i18n.t('time_off.taken_tooltip.this_cycle')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Total)
